import {Component, OnInit, Input} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as languageConfig from '../../../assets/i18n/configuration/configuration.json';
import {
  Router,
  NavigationExtras
} from '@angular/router';
import { Dialog } from '@eds/vanilla';
declare var jQuery: any;
@Component({
  selector: 'page-link-block',
  templateUrl: './page-link-block.component.html',
  styleUrls: ['./page-link-block.component.css'],
  providers: []
})

export class LandingPageLinkComponent implements OnInit {
  @Input() title: string;
  @Input() description: string;
  @Input() imageSrc: string;
  @Input() routeLink: string;
  externalLink: string;
textDir:any;
  constructor(private router: Router) {
    this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    const regexp = new RegExp('^(http)');
    if (regexp.test(this.routeLink)) {
        this.externalLink = this.routeLink;
        this.routeLink = undefined;
    }
  }

  navToNextPage(data) {
    this.router.navigate([data]);
  }

  getRequestCount() {
    /*
    this.requestService.getRequestCount("pending").subscribe(
      (response) => {
        console.log("VALUE RECEIVED: " + JSON.stringify(response));
        this.requestCount = response.count;
      },
      (err) => {

        console.log("ERROR: " + err);
      },
      () => {

        console.log("COMPLETED");
      }
    )
    */
  }

  moduleLink(route) {
    if (route.link === 'contactsupport'){
      // jQuery('#support').modal('show');
      this.openDialogModal('support');
    }
    if (route.extlink) {
        window.open(route.extlink);
    }else if (route.link) {
      if (route.link !== 'contactsupport'){
        this.router.navigate([route.link]);
      }
    }
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }

}
